// Imports Angular
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DContextoMuisca } from '@dian/core';
import { GeneralService } from '../../services/general.service';
import { DDevolucionesServicios } from '../../../../node_modules/@dian-api/devoluciones/src/servicios/ddevoluciones.servicios';
import { HttpClient, HttpClientModule } from '@angular/common/http';

@Component({
    moduleId: module.id,
    selector: 'ingreso',
    templateUrl: 'ingreso.component.html',
    styleUrls: ['ingreso.component.css'],
   
    
})
export class IngresoComponent implements OnInit {
    public cards : {titulo: string; descripcion: string; icono: string; link: string; visible: boolean}[];
    show_item_description = false;
    datosUsuario: DContextoMuisca;
    datosDevoluciones: DDevolucionesServicios;
    private tiempo:Date;
    datosFirmaYGrancondtribuyente?: {esFirmaElectronica: boolean; granContribuyente: boolean};
    boolDevoluciones:boolean = false;
    urlDevoluciones:string='';

    /**
     * @constructs ConfiguracionSelectorComponent
     */
    constructor(
        private router: Router,
        private generalService: GeneralService
    ) { 
      
        this.generalService.datosRespuesta$.subscribe(res =>{
          this.datosUsuario = res;
        });
        
        this.generalService.datosFirmaYTipoContribuyente$.subscribe(res =>{
          this.datosFirmaYGrancondtribuyente = res;
          if(!res.esFirmaElectronica || !res.granContribuyente){
            const pagoPorCuotasCard = this.cards.find(item => item.titulo === 'Pago por cuotas');
            if (pagoPorCuotasCard) pagoPorCuotasCard.visible = false;
          }
          if (res.esFirmaElectronica) {
            const definitivosCard = this.cards.find(item => item.titulo === 'Formularios definitivos listos para presentación');
            if (definitivosCard) definitivosCard.visible = false;
          } 
        })
      this.generalService.devoluciones$.subscribe(res =>{
          this.boolDevoluciones = res;
         // const prueba =''+this.generalService.getDevolucioneshref()+'/'+this.generalService.getrequestEnvio();
          this.urlDevoluciones =''+this.generalService.getDevolucioneshref()+'/'+this.generalService.getrequestEnvio();
          this.construirMenu();
         
      });
        this.tiempo = new Date();               
        let tiempoReal = new Date();                    
        setInterval(()=>{
            tiempoReal.setSeconds(tiempoReal.getSeconds() + 1);
            this.tiempo = new Date(tiempoReal);                    
        }, 1000);
    }

    /**
    * Interface for on init document.
    * @interface
    */
    ngOnInit() {
      if (!this.datosUsuario) {
        this.datosUsuario = this.generalService.getDatosUsuario();
      }
      if(!this.cards)
      {
        this.boolDevoluciones = this.generalService.getDevoluciones();
        this.urlDevoluciones =''+this.generalService.getDevolucioneshref()+'/'+this.generalService.getrequestEnvio();
        this.construirMenu();
      }
      if (!this.datosFirmaYGrancondtribuyente) {
        this.datosFirmaYGrancondtribuyente = this.generalService.getDatosFirmaYGranContribuyente();
        if(this.datosFirmaYGrancondtribuyente && (!this.datosFirmaYGrancondtribuyente.esFirmaElectronica || !this.datosFirmaYGrancondtribuyente.granContribuyente)){
          const pagoPorCuotasCard = this.cards.find(item => item.titulo === 'Pago por cuotas');
          if (pagoPorCuotasCard) pagoPorCuotasCard.visible = false;
        }
        if (this.datosFirmaYGrancondtribuyente  && this.datosFirmaYGrancondtribuyente.esFirmaElectronica) {
          const definitivosCard = this.cards.find(item => item.titulo === 'Formularios definitivos listos para presentación');
          if (definitivosCard) definitivosCard.visible = false;
        } 
      }
     

    }

    private construirMenu() {
        this.cards = [
          {
            titulo: 'Haga su declaración de renta',
            descripcion: 'Realice su declaración de renta del año gravable (correspondiente al año anterior) o de forma extemporánea (fuera del plazo reglamentado).',
            icono: 'crear',
            link: '/ingreso/crearFormulario',
            visible: true
          },
          {
            titulo: 'Edite su declaración de renta',
            descripcion: 'Encuentre aquí los borradores creados y comenzados, que aún están pendientes por completar. Podrá <b>editar, descargar y anular sus borradores.</b>',
            icono: 'tareas',
            link: '/ingreso/borradores',
            visible: true
          },
          {
            titulo: 'Presente declaración de renta por fracción de año',
            descripcion: 'La mayoría de los contribuyentes no están obligados a presentar este tipo de declaración, excepto en el caso de sucesiones y sociedades liquidadas registradas ante la Cámara de comercio.',
            icono: 'agregar-fecha',
            link: '/ingreso/fraccion',
            visible: true
          },
          {
            titulo: 'Formularios definitivos listos para presentación',
            descripcion: 'Aquí podrá <b>descargar, nuevo y pagar</b> su borrador definitivo para su presentación de renta o fracción de año.',
            icono: 'definitivos',
            link: '/ingreso/definitivos',
            visible: true
          },
          {
            titulo: 'Declaraciones de renta presentadas',
            descripcion: 'Encuentre aquí el histórico de sus declaraciones presentadas. Podrá <b>corregir, descargar y pagar su declaración.</b>',
            icono: 'presentados',
            link: 'ingreso/presentados',
            visible: true
          },
          {
            titulo: 'Pago por cuotas',
            descripcion: 'Los grandes contribuyentes pueden pagar aquí sus impuestos en las cuotas fijadas respecto al calendario tributario.',
            icono: 'pago-cuotas',
            link: '/ingreso/cuotas',
            visible: true,
          },
         
          {
            titulo: 'Devolución de saldo a favor',
            descripcion: 'Consulte el estado del proceso y revise el historial de devoluciones.',
            icono: 'devoluciones',
            link: this.urlDevoluciones,
            visible: this.boolDevoluciones,
          },
          {
            titulo: 'Ayuda',
            descripcion: 'Acceda al material de apoyo que lo guiará en cada paso <a target="_blank" class="router-link" href="https://micrositios.dian.gov.co/renta-personas-naturales-ag-2025/">aquí</a>',
            icono: 'pregunta',
            link: '',
            visible: true,
          },
         
        ];
      }
      

      redirect(item){
        if(item.icono==='devoluciones')
        {
          if ( item.link.includes("http://") ||  item.link.includes("https://"))
              window.location.href =  item.link;
        }
        else
        {
          item.link ? this.router.navigate([item.link]) : this.router.navigate(['/']);;
        }
      }
      

    

}




// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/ingreso/ingreso.component.ts